const accessHR = {

    GROUP_TYPE_LIST: { name: 'Group Type', path: '/group-type-list' },
    ADD_GROUP_TYPE: { name: 'Create Group Type', path: '/create-group-type' },
    UPDATE_GROUP_TYPE: { name: 'Edit Group Type', path: '/edit-group-type' },
    DELETE_GROUP_TYPE: { name: 'Delete Group Type', path: '/delete-group-type' },

    GROUP_LIST: { name: 'Group', path: '/group-list' },
    ADD_GROUP: { name: 'Create Group', path: '/create-group' },
    UPDATE_GROUP: { name: 'Edit Group', path: '/edit-group' },
    DELETE_GROUP: { name: 'Delete Group', path: '/delete-group' },

    DEPARTMENT_LIST: { name: 'Department', path: '/department-list' },
    ADD_DEPARTMENT: { name: 'Create Department', path: '/create-department' },
    UPDATE_DEPARTMENT: { name: 'Edit Department', path: '/edit-department' },
    DELETE_DEPARTMENT: { name: 'Delete Department', path: '/delete-department' },

    EMPLOYEE_LIST: { name: 'Employee', path: '/employee-list' },
    ADD_EMPLOYEE: { name: 'Create Employee', path: '/create-employee' },
    UPDATE_EMPLOYEE: { name: 'Edit Employee', path: '/edit-employee' },
    EMPLOYEE_DETAILS: { name: 'Employee Details', path: '/employee-details' },
    DELETE_EMPLOYEE: { name: 'Delete Employee', path: '/delete-employee' },

}

export default accessHR;